export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const MONTHS_SHORT = MONTHS.map((m) => m.slice(0, 3));
export const DAYS_SHORT = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const startOfDay = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; };
export const sameDay = (a, b) => a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
export const addMonths = (d, n) => { const x = new Date(d); x.setMonth(x.getMonth() + n); return x; };
export const startOfMonth = (d) => new Date(d.getFullYear(), d.getMonth(), 1);
export const startOfWeek = (d) => { const x = startOfDay(d); const day = (x.getDay() + 6) % 7; return addDays(x, -day); };
export const daysBetween = (a, b) => Math.round((startOfDay(b) - startOfDay(a)) / 86400000) + 1;

export const fmt = (d) => {
    if (!d) return '—';
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    return `${dd}/${mm}/${d.getFullYear()}`;
};

export const fmtShort = (d) => {
    if (!d) return '—';
    const dd = String(d.getDate()).padStart(2, '0');
    const mmm = MONTHS_SHORT[d.getMonth()];
    return `${dd} ${mmm} ${d.getFullYear()}`;
};

export const TODAY = () => startOfDay(new Date());
export const MAX_DATE = () => TODAY();
export const MIN_YEAR = 2000;
export const FAR_FUTURE = new Date(2099, 11, 31);

export const weekdayMap = {
    mon: 1,
    monday: 1,
    tue: 2,
    tues: 2,
    tuesday: 2,
    wed: 3,
    weds: 3,
    wednesday: 3,
    thu: 4,
    thur: 4,
    thurs: 4,
    thursday: 4,
    fri: 5,
    friday: 5,
    sat: 6,
    saturday: 6,
    sun: 0,
    sunday: 0
};
export const monthMap = (() => {
    const m = {};
    MONTHS.forEach((name, i) => {
        m[name.toLowerCase()] = i;
        m[name.slice(0, 3).toLowerCase()] = i;
    });
    m.sept = 8;
    return m;
})();
export const wordToNum = {
    first: 1,
    one: 1,
    second: 2,
    two: 2,
    third: 3,
    three: 3,
    fourth: 4,
    four: 4,
    fifth: 5,
    five: 5,
    sixth: 6,
    six: 6,
    seventh: 7,
    seven: 7,
    eighth: 8,
    eight: 8,
    ninth: 9,
    nine: 9,
    tenth: 10,
    ten: 10,
    eleventh: 11,
    eleven: 11,
    twelfth: 12,
    twelve: 12,
    thirteenth: 13,
    thirteen: 13,
    fourteenth: 14,
    fourteen: 14,
    fifteenth: 15,
    fifteen: 15,
    sixteenth: 16,
    sixteen: 16,
    seventeenth: 17,
    seventeen: 17,
    eighteenth: 18,
    eighteen: 18,
    nineteenth: 19,
    nineteen: 19,
    twentieth: 20,
    twenty: 20,
    'twenty-first': 21,
    'twenty-one': 21,
    'twenty-second': 22,
    'twenty-two': 22,
    'twenty-third': 23,
    'twenty-three': 23,
    'twenty-fourth': 24,
    'twenty-four': 24,
    'twenty-fifth': 25,
    'twenty-five': 25,
    'twenty-sixth': 26,
    'twenty-six': 26,
    'twenty-seventh': 27,
    'twenty-seven': 27,
    'twenty-eighth': 28,
    'twenty-eight': 28,
    'twenty-ninth': 29,
    'twenty-nine': 29,
    thirtieth: 30,
    thirty: 30,
    'thirty-first': 31,
    'thirty-one': 31
};
const TENS_WORDS = {
    twenty: 20, thirty: 30, forty: 40, fifty: 50, sixty: 60, seventy: 70, eighty: 80, ninety: 90
};
function parseWordNumber(s) {
    const parts = s.replace(/-/g, ' ').trim().split(/\s+/);
    if (parts.length === 1) return wordToNum[parts[0]] ?? TENS_WORDS[parts[0]] ?? null;
    if (parts.length === 2) {
        const tens = TENS_WORDS[parts[0]]; const
            ones = wordToNum[parts[1]];
        if (tens !== undefined && ones !== undefined && ones < 10) return tens + ones;
    }
    return null;
}
export function tryWord(s) {
    return wordToNum[s] !== undefined ? wordToNum[s] : null;
}

export function tryYearWords(s) {
    const tokens = s.trim().split(/\s+/);
    if (tokens.length === 0) return null;
    if (tokens.length === 1 && /^\d{2,4}$/.test(tokens[0])) return normalizeYear(+tokens[0]);
    if (tokens[0] === 'twenty' && tokens.length >= 2) {
        if (tokens[1] === 'twenty' && tokens.length >= 3) {
            const last = parseWordNumber(tokens.slice(2).join(' '));
            if (last !== null) return 2020 + last;
        }
        const tail = parseWordNumber(tokens.slice(1).join(' '));
        if (tail !== null) return tail <= 9 ? 2020 + tail : 2000 + tail;
    }
    if (tokens[0] === 'nineteen' && tokens.length >= 2) {
        const tail = parseWordNumber(tokens.slice(1).join(' '));
        if (tail !== null) return 1900 + tail;
    }
    return null;
}

export const normalizeYear = (y) => (y < 100 ? (y < 50 ? 2000 + y : 1900 + y) : y);

const DAY_TOKEN = '(\\d{1,2}(?:st|nd|rd|th)?|[a-z]+(?:-[a-z]+)?)';
const MONTH_TOKEN = '([a-z]+)';

export function parseDayToken(token) {
    if (!token) return null;
    const t = token.toLowerCase().trim();
    const numeric = t.match(/^(\d{1,2})(?:st|nd|rd|th)?$/);
    if (numeric) {
        const day = +numeric[1];
        return day >= 1 && day <= 31 ? day : null;
    }
    const wordDay = tryWord(t);
    return wordDay !== null ? wordDay : null;
}

function parseMonthToken(token) {
    if (!token) return undefined;
    return monthMap[token.toLowerCase().trim()];
}

function parseYearToken(raw, fallbackYear) {
    if (!raw) return fallbackYear;
    const trimmed = raw.trim();
    const yw = tryYearWords(trimmed);
    if (yw !== null) return yw;
    if (/^\d{2,4}$/.test(trimmed)) return normalizeYear(+trimmed);
    return fallbackYear;
}

function buildCalendarDate(day, monthIndex, year) {
    if (day === null || day < 1 || day > 31 || monthIndex === undefined) return null;
    const dt = new Date(year, monthIndex, day);
    if (dt.getFullYear() !== year || dt.getMonth() !== monthIndex || dt.getDate() !== day) {
        return null;
    }
    return dt;
}

export function parseNumericDateInput(raw, today = TODAY()) {
    const s = raw.trim().toLowerCase().replace(/\s+/g, ' ');
    if (!s) return null;

    let m = s.match(/^(\d{1,2})[/.-](\d{1,2})(?:[/.-](\d{2,4}))?$/);
    if (m) {
        const day = +m[1];
        const month = +m[2];
        const year = m[3] ? normalizeYear(+m[3]) : today.getFullYear();
        if (month >= 1 && month <= 12) {
            return buildCalendarDate(day, month - 1, year);
        }
    }

    m = s.match(/^(\d{4})[/.-](\d{1,2})[/.-](\d{1,2})$/);
    if (m) {
        return buildCalendarDate(+m[3], +m[2] - 1, +m[1]);
    }

    return null;
}

export function parseSingle(raw, today) {
    const s = raw.trim().toLowerCase().replace(/,/g, '').replace(/\s+/g, ' ');
    if (!s) return null;

    const numeric = parseNumericDateInput(s, today);
    if (numeric) return numeric;

    let m = s.match(new RegExp(`^${DAY_TOKEN}\\s+(?:of\\s+)?${MONTH_TOKEN}(?:\\s+(.+))?$`));
    if (m) {
        const day = parseDayToken(m[1]);
        const monthIndex = parseMonthToken(m[2]);
        const year = parseYearToken(m[3], today.getFullYear());
        const dt = buildCalendarDate(day, monthIndex, year);
        if (dt) return dt;
    }

    m = s.match(new RegExp(`^${MONTH_TOKEN}\\s+${DAY_TOKEN}(?:\\s+(.+))?$`));
    if (m) {
        const monthIndex = parseMonthToken(m[1]);
        const day = parseDayToken(m[2]);
        const year = parseYearToken(m[3], today.getFullYear());
        const dt = buildCalendarDate(day, monthIndex, year);
        if (dt) return dt;
    }
    if (s === 'today') return today;
    if (s === 'yesterday') return addDays(today, -1);
    if (s === 'tomorrow') return addDays(today, 1);
    if (weekdayMap[s] !== undefined) {
        const wd = weekdayMap[s]; const
            curr = today.getDay();
        let diff = wd - curr;
        if (diff > 0) diff -= 7;
        return addDays(today, diff);
    }
    return null;
}

export function parseSmart(raw, maxDate) {
    if (!raw) return null;
    const s = raw.trim().toLowerCase().replace(/\s+/g, ' ');
    if (!s) return null;
    const today = TODAY();
    const clamp = (d) => (d > maxDate ? maxDate : d);

    if (s === 'today') return { start: today, end: today };
    if (s === 'yesterday') { const d = addDays(today, -1); return { start: d, end: d }; }
    if (s === 'tomorrow') { const d = clamp(addDays(today, 1)); return { start: d, end: d }; }
    if (s === 'ytd' || s === 'this year') return { start: new Date(today.getFullYear(), 0, 1), end: today };
    if (s === 'mtd' || s === 'this month') return { start: startOfMonth(today), end: today };
    if (s === 'qtd' || s === 'this quarter') {
        const q = Math.floor(today.getMonth() / 3);
        return { start: new Date(today.getFullYear(), q * 3, 1), end: today };
    }
    if (s === 'wtd' || s === 'this week') return { start: startOfWeek(today), end: today };

    let m = s.match(/^last\s+(\d+)\s*(d|day|days|w|wk|week|weeks|m|mo|month|months|y|yr|year|years)$/);
    if (m) {
        const n = +m[1]; const
            unit = m[2];
        let start;
        if (unit.startsWith('d')) start = addDays(today, -(n - 1));
        else if (unit.startsWith('w')) start = addDays(today, -n * 7 + 1);
        else if (unit.startsWith('m')) start = addMonths(today, -n);
        else start = new Date(today.getFullYear() - n, today.getMonth(), today.getDate());
        return { start, end: today };
    }
    m = s.match(/^(\d+)\s*(d|day|days|w|wk|week|weeks|m|mo|month|months|y|yr|year|years)$/);
    if (m && !s.startsWith('in ')) {
        const n = +m[1]; const
            unit = m[2];
        let start;
        if (unit.startsWith('d')) start = addDays(today, -(n - 1));
        else if (unit.startsWith('w')) start = addDays(today, -n * 7 + 1);
        else if (unit.startsWith('m')) start = addMonths(today, -n);
        else start = new Date(today.getFullYear() - n, today.getMonth(), today.getDate());
        return { start, end: today };
    }

    if (s === 'last week') {
        const thisMon = startOfWeek(today);
        return { start: addDays(thisMon, -7), end: addDays(thisMon, -1) };
    }
    if (s === 'last month') {
        return {
            start: new Date(today.getFullYear(), today.getMonth() - 1, 1),
            end: new Date(today.getFullYear(), today.getMonth(), 0)
        };
    }
    if (s === 'last quarter') {
        const q = Math.floor(today.getMonth() / 3);
        if (q === 0) {
            return {
                start: new Date(today.getFullYear() - 1, 9, 1),
                end: new Date(today.getFullYear() - 1, 11, 31)
            };
        }
        return {
            start: new Date(today.getFullYear(), (q - 1) * 3, 1),
            end: new Date(today.getFullYear(), q * 3, 0)
        };
    }
    if (s === 'last year') {
        return {
            start: new Date(today.getFullYear() - 1, 0, 1),
            end: new Date(today.getFullYear() - 1, 11, 31)
        };
    }

    m = s.match(/^q([1-4])\s*(\d{2,4})?$/);
    if (m) {
        const q = +m[1];
        const yr = m[2] ? normalizeYear(+m[2]) : today.getFullYear();
        return {
            start: new Date(yr, (q - 1) * 3, 1),
            end: clamp(new Date(yr, q * 3, 0))
        };
    }

    m = s.match(/^(next|last|this)\s+([a-z]+)$/);
    if (m) {
        const dir = m[1];
        const wd = weekdayMap[m[2]];
        if (wd !== undefined) {
            const curr = today.getDay();
            let diff = wd - curr;
            if (dir === 'next') diff = diff <= 0 ? diff + 7 : diff;
            else if (dir === 'last') diff = diff >= 0 ? diff - 7 : diff;
            const d = clamp(addDays(today, diff));
            return { start: d, end: d };
        }
    }

    m = s.match(/^in\s+(\d+)\s+(day|days|week|weeks|month|months)$/);
    if (m) {
        const n = +m[1]; const
            unit = m[2];
        let d;
        if (unit.startsWith('day')) d = addDays(today, n);
        else if (unit.startsWith('week')) d = addDays(today, n * 7);
        else d = addMonths(today, n);
        d = clamp(d);
        return { start: d, end: d };
    }
    m = s.match(/^([a-z]+(?:-[a-z]+)?)\s+(day|days|week|weeks|month|months|year|years)\s+ago$/);
    if (m) {
        const n = parseWordNumber(m[1]);
        if (n !== null) {
            const unit = m[2];
            let d;
            if (unit.startsWith('day')) d = addDays(today, -n);
            else if (unit.startsWith('week')) d = addDays(today, -n * 7);
            else if (unit.startsWith('month')) d = addMonths(today, -n);
            else d = new Date(today.getFullYear() - n, today.getMonth(), today.getDate());
            return { start: d, end: d };
        }
    }
    m = s.match(/^(\d+)\s+(day|days|week|weeks|month|months|year|years)\s+ago$/);
    if (m) {
        const n = +m[1]; const
            unit = m[2];
        let d;
        if (unit.startsWith('day')) d = addDays(today, -n);
        else if (unit.startsWith('week')) d = addDays(today, -n * 7);
        else if (unit.startsWith('month')) d = addMonths(today, -n);
        else d = new Date(today.getFullYear() - n, today.getMonth(), today.getDate());
        return { start: d, end: d };
    }

    const sepRe = /\s*(?:to|->|→|–|—|\sthru\s|\suntil\s)\s*/;
    let parts = null;
    if (sepRe.test(s)) parts = s.split(sepRe);
    else if (s.includes(' - ')) {
        const p = s.split(' - ');
        if (p.length === 2) parts = p;
    }
    if (parts && parts.length === 2) {
        const a = parseSingle(parts[0], today);
        const b = parseSingle(parts[1], today);
        if (a && b) {
            const [start, end] = a <= b ? [a, b] : [b, a];
            return { start, end: clamp(end) };
        }
    }

    const wordYear = tryYearWords(s);
    if (wordYear !== null && wordYear >= MIN_YEAR) {
        return { start: new Date(wordYear, 0, 1), end: clamp(new Date(wordYear, 11, 31)) };
    }

    const single = parseSingle(s, today);
    if (single) return { start: single, end: single };

    return null;
}

export const PRESETS = [
    { label: 'Today', value: 'today' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'Last 7d', value: 'last 7 days' },
    { label: 'Last 30d', value: 'last 30 days' },
    { label: 'Last 90d', value: 'last 90 days' },
    { label: 'MTD', value: 'mtd' },
    { label: 'QTD', value: 'qtd' },
    { label: 'YTD', value: 'ytd' },
    { label: 'Last month', value: 'last month' },
    { label: 'Last year', value: 'last year' }
];

export const SINGLE_PRESETS = [
    { label: 'Today', value: 'today' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'Last month', value: 'last month' },
    { label: 'Last year', value: 'last year' }
];

export function resolveSinglePresetDate(parsed, maxDate, filterDate, minDate) {
    if (!parsed?.start) return null;

    let start = startOfDay(parsed.start);
    let end = startOfDay(parsed.end || parsed.start);
    if (start > end) [start, end] = [end, start];

    let candidate = end > maxDate ? maxDate : end;
    if (candidate < start) candidate = start;
    if (minDate && candidate < minDate) return null;

    if (!filterDate) return candidate;

    while (candidate >= start) {
        if (candidate <= maxDate && filterDate(candidate)) return candidate;
        candidate = addDays(candidate, -1);
    }

    return null;
}

export const EXAMPLES = [
    'last 30 days', 'Q1 2024', 'YTD', 'MTD',
    'last quarter', 'last month', 'last year',
    'yesterday', 'today', 'last friday',
    'March 5', '5 March 2024', 'tenth June 2024',
    '3/5/24', '2024-03-05', '5th of March',
    'in 3 days', '2 weeks ago', 'this week',
    '30d', 'Q3 2023', 'twenty twenty four'
];

export const ICON_CAL = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>';
export const ICON_L = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
export const ICON_R = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
export const ICON_SPARK = '<svg class="spark" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>';
export const ICON_X = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

export function nextYM(y, m) { return m === 11 ? [y + 1, 0] : [y, m + 1]; }
export function prevYM(y, m) { return m === 0 ? [y - 1, 11] : [y, m - 1]; }

export function getPreviewRange({
    draftStart, draftEnd, hoverDate, selectionMode
}) {
    const ds = draftStart;
    const de = draftEnd;
    const h = hoverDate;
    let effStart = ds;
    let effEnd = de;
    if (h) {
        if (selectionMode === 'start') {
            effStart = h;
            if (de && h > de) effEnd = null;
        } else {
            effEnd = h;
        }
    }
    if (effStart && effEnd && effStart > effEnd) {
        [effStart, effEnd] = [effEnd, effStart];
    }
    return [effStart, effEnd];
}

export function applyRangeClasses(classes, d, rangeContext) {
    const [a, b] = getPreviewRange(rangeContext);
    if (!a && !b) return;

    if (rangeContext.isSingle) {
        const single = a || b;
        if (single && sameDay(d, single)) classes.push('selected');
        return;
    }

    const isA = a && sameDay(d, a);
    const isB = b && sameDay(d, b);
    if (a && b) {
        const dd = startOfDay(d).getTime();
        const at = startOfDay(a).getTime();
        const bt = startOfDay(b).getTime();
        if (dd >= at && dd <= bt && !isA && !isB) classes.push('in-range');
    }
    if (isA || isB) classes.push('selected');
    if (isA) classes.push('range-start');
    if (isB) classes.push('range-end');
}

export function smartPlaceholder(selectionMode, isSinglePicker = false) {
    if (isSinglePicker) {
        return 'Type a date - “5 march” , “yesterday” , “Q1 2024”';
    }
    return selectionMode === 'end'
        ? 'Type an end date — "20 march", "today", "Q1 2024"…'
        : 'Type a start date — "5 march", "yesterday", "Q1 2024"…';
}

export function smartApplicableDate(smartPreview, selectionMode) {
    if (!smartPreview) return null;
    const p = smartPreview;
    if (selectionMode === 'end') return p.end || p.start;
    return p.start;
}

export function renderInlinePreview(smartPreview, selectionMode) {
    const d = smartApplicableDate(smartPreview, selectionMode);
    if (!d) return '';
    const role = selectionMode === 'end' ? 'End' : 'Start';
    return `→ <span class="role-tag">${role}</span> <span class="v">${fmt(d)}</span>`;
}

export function renderYears(viewYear, maxYear) {
    const years = [];
    for (let y = MIN_YEAR; y <= maxYear; y++) years.push(y);
    return years.map((y) => `<button class="chip ${y === viewYear ? 'selected' : ''}" data-year="${y}">${y}</button>`).join('');
}

export function renderMonths(viewYear, viewMonth, maxDate) {
    return MONTHS_SHORT.map((m, i) => {
        const disabled = new Date(viewYear, i, 1) > maxDate;
        return `<button class="chip ${i === viewMonth ? 'selected' : ''}" data-month="${i}" ${disabled ? 'disabled' : ''}>${m}</button>`;
    }).join('');
}

export function dayCellHTML(d, month, today, maxDate, focusedDate, rangeContext) {
    const inMonth = d.getMonth() === month;
    const isFuture = d > maxDate;
    const isToday = sameDay(d, today);
    const classes = ['day-cell'];
    if (!inMonth) classes.push('out-month');
    if (isToday) classes.push('today');
    const ds = `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
    applyRangeClasses(classes, d, rangeContext);
    const tabidx = (inMonth && focusedDate && sameDay(d, focusedDate)) ? 0 : -1;
    return `<button class="${classes.join(' ')}" ${isFuture ? 'disabled' : ''} data-day="${ds}" data-ts="${d.getTime()}" tabindex="${tabidx}" aria-label="${fmt(d)}${isToday ? ' (today)' : ''}">${d.getDate()}</button>`;
}

export function monthPanelHTML(year, month, isLeft, panelContext) {
    const {
        viewYear, viewMonth, selectionMode, maxDate, focusedDate, rangeContext
    } = panelContext;
    const first = new Date(year, month, 1);
    const gridStart = startOfWeek(first);
    const today = TODAY();
    const cellsHtml = [];
    for (let i = 0; i < 42; i++) {
        const d = addDays(gridStart, i);
        cellsHtml.push(dayCellHTML(d, month, today, maxDate, focusedDate, rangeContext));
    }
    const canPrev = !(year === MIN_YEAR && month === 0);
    const canNext = isLeft
        ? new Date(viewYear, viewMonth + 1, 1) <= startOfMonth(maxDate)
        : new Date(year, month + 1, 1) <= startOfMonth(maxDate);
    const role = isLeft ? 'start' : 'end';
    const roleLabel = isLeft ? 'Start' : 'End';
    const isActive = selectionMode === role;
    return `
    <div class="month-panel ${isActive ? 'role-active' : ''}">
      <div class="month-role">
        <span class="month-role-dot"></span>
        <span>${roleLabel}</span>
      </div>
      <div class="month-header">
        <button class="nav-btn" data-nav="prev" ${!canPrev ? 'disabled' : ''} aria-label="Previous month">${ICON_L}</button>
        <div class="month-title">${MONTHS[month]} ${year}</div>
        <button class="nav-btn" data-nav="next" ${!canNext ? 'disabled' : ''} aria-label="Next month">${ICON_R}</button>
      </div>
      <div class="dow-row">
        ${DAYS_SHORT.map((dow) => `<div class="dow-label">${dow}</div>`).join('')}
      </div>
      <div class="day-grid">
        ${cellsHtml.join('')}
      </div>
    </div>
  `;
}

export function popupHTML(state, maxDate, maxYear) {
    const { draftStart, draftEnd } = state;
    const rangeContext = {
        draftStart: state.draftStart,
        draftEnd: state.draftEnd,
        hoverDate: state.hoverDate,
        selectionMode: state.selectionMode
    };
    const panelContext = {
        viewYear: state.viewYear,
        viewMonth: state.viewMonth,
        selectionMode: state.selectionMode,
        maxDate,
        focusedDate: state.focusedDate,
        rangeContext
    };
    const modeName = state.selectionMode === 'end' ? 'End' : 'Start';
    const modeHint = state.selectionMode === 'end'
        ? 'Click a date or type below'
        : 'Click a date, then pick end';
    return `
    <div class="popup-mode">
      <span class="popup-mode-dot"></span>
      <span class="popup-mode-text">Picking <span class="mode-name">${modeName}</span> date</span>
      <span class="popup-mode-hint">${modeHint}</span>
    </div>
    <div class="smart-bar">
      <div class="smart-input-wrap" id="smartInputWrap">
        ${ICON_SPARK}
        <input class="smart-input" id="smartInput" value="${state.smartInput.replace(/"/g, '&quot;')}" placeholder='${smartPlaceholder(state.selectionMode)}'/>
        <span class="smart-preview-inline" id="smartPreviewInline" style="${state.smartPreview ? '' : 'display:none'}">${state.smartPreview ? renderInlinePreview(state.smartPreview, state.selectionMode) : ''}</span>
        <button class="smart-apply" id="smartApply" style="${state.smartPreview ? '' : 'display:none'}">Apply ↵</button>
        <button class="smart-clear" id="smartClear" style="${state.smartInput ? '' : 'display:none'}">${ICON_X}</button>
      </div>
      <div id="smartErrorBox">${state.smartError ? '<div class="smart-error">Can\'t parse — try "last 30 days", "5 march 2024", or "3/5/24"</div>' : ''}</div>
    </div>
    <div class="presets">
      ${PRESETS.map((p) => `<button class="preset" data-preset="${p.value}">${p.label}</button>`).join('')}
    </div>
    <div class="nav-section">
      <div class="nav-row">
        <div class="nav-label">Year</div>
        <div class="strip-wrap">
          <button class="strip-arrow" id="yearPrev" aria-label="Previous year">${ICON_L}</button>
          <div class="strip" id="yearStrip">${renderYears(state.viewYear, maxYear)}</div>
          <button class="strip-arrow" id="yearNext" aria-label="Next year">${ICON_R}</button>
        </div>
      </div>
      <div class="nav-row">
        <div class="nav-label">Month</div>
        <div class="strip" id="monthStrip">${renderMonths(state.viewYear, state.viewMonth, maxDate)}</div>
      </div>
    </div>
    <div class="status-bar">
      <button class="role-pill ${state.selectionMode === 'start' ? 'active' : ''}" data-role="start" type="button">
        <span class="role-label">Start ${state.selectionMode === 'start' ? '· picking' : ''}</span>
        <span class="role-value ${!draftStart ? 'role-placeholder' : ''}">${draftStart ? fmt(draftStart) : 'pick a date'}</span>
      </button>
      <span class="status-arrow">→</span>
      <button class="role-pill ${state.selectionMode === 'end' ? 'active' : ''}" data-role="end" type="button">
        <span class="role-label">End ${state.selectionMode === 'end' ? '· picking' : ''}</span>
        <span class="role-value ${!draftEnd ? 'role-placeholder' : ''}">${draftEnd ? fmt(draftEnd) : 'pick a date'}</span>
      </button>
    </div>
    <div class="calendars">
      ${monthPanelHTML(state.viewYear, state.viewMonth, true, panelContext)}
      ${monthPanelHTML(...nextYM(state.viewYear, state.viewMonth), false, panelContext)}
    </div>
    <div class="popup-footer">
      <span class="footer-help">
        <span class="v">←→↑↓</span> nav · <span class="v">⇧←→</span> month · <span class="v">⇧↑↓</span> year · <span class="v">Enter</span> pick · <span class="v">Esc</span> close
      </span>
    </div>
  `;
}

export function createInitialState(maxDate) {
    return {
        start: new Date(maxDate.getFullYear() - 1, maxDate.getMonth(), maxDate.getDate()),
        end: maxDate,
        draftStart: null,
        draftEnd: null,
        selectionMode: 'start',
        open: false,
        openedFrom: 'start',
        viewYear: maxDate.getFullYear(),
        viewMonth: maxDate.getMonth(),
        hoverDate: null,
        smartInput: '',
        smartPreview: null,
        smartError: false,
        focusedDate: null,
        shouldFocusDayCell: false
    };
}

export function getRangeContext(state) {
    return {
        draftStart: state.draftStart,
        draftEnd: state.draftEnd,
        hoverDate: state.hoverDate,
        selectionMode: state.selectionMode
    };
}

export function getMonthGridDays(year, month) {
    const first = new Date(year, month, 1);
    const gridStart = startOfWeek(first);
    const days = [];
    for (let i = 0; i < 42; i++) days.push(addDays(gridStart, i));
    return days;
}

export function getDayCellClassName(d, month, today, rangeContext) {
    const classes = ['day-cell'];
    if (d.getMonth() !== month) classes.push('out-month');
    if (sameDay(d, today)) classes.push('today');
    applyRangeClasses(classes, d, rangeContext);
    return classes.join(' ');
}

export const resolvePickerMaxDate = (maxDate, disableFutureDates = true) => {
    const today = startOfDay(new Date());
    const explicit = maxDate ? startOfDay(maxDate) : null;
    if (disableFutureDates) {
        if (!explicit) return today;
        return explicit > today ? today : explicit;
    }
    return explicit;
};

export const parseSlashDateInput = (raw) => {
    const parsed = parseNumericDateInput(raw, TODAY());
    return parsed ? startOfDay(parsed) : null;
};



